import { useMemo } from 'react'

import { useAPIGetPenetapanPredikatKinerjaStep } from 'api/kinerja/useAPIKinerja'
import useDemoContext from 'app/KinerjaPage/hooks/useDemoContext'
import { LangkahObservasiCard } from 'app/KinerjaPage/pages/PelaksanaanV2/components/LangkahObservasiCard'
import { PENGELOLAAN_KINERJA_KS_PENILAI_PATH } from 'app/KinerjaShared/constants/path'
import { PENETAPAN_PREDIKAT_KINERJA_STEPS } from 'app/KinerjaShared/constants/penetapanPredikatKinerja'

import type {
  LangkahObservasiCardProps,
  LangkahObservasiState,
} from 'app/KinerjaPage/pages/PelaksanaanV2/components/LangkahObservasiCard'

export const LangkahPenetapanPredikatKinerjaCard = (
  props: LangkahObservasiCardProps
) => {
  const { isDemoMode } = useDemoContext()

  const { data, isLoading } = useAPIGetPenetapanPredikatKinerjaStep({
    params: {
      npsn: props?.npsn,
    },
    options: {
      useErrorBoundary: false,
      staleTime: 60 * 60 * 1000, // 1 hour
    },
    isDemoMode,
  })

  const overrideState: LangkahObservasiState = useMemo(() => {
    const currentStepOrder =
      PENETAPAN_PREDIKAT_KINERJA_STEPS[data?.data?.submissionStep]?.order ?? 0
    const cardStepOrder = PENETAPAN_PREDIKAT_KINERJA_STEPS['SUBMIT_GURU'].order

    if (cardStepOrder === currentStepOrder) {
      if (data?.data?.state === 'DRAFT') return 'draft'
      return 'unlocked'
    }
    if (currentStepOrder > cardStepOrder) return 'done'
    return 'locked'
  }, [data])

  const ctaURL = (): string => {
    switch (overrideState) {
      case 'done':
        return `${PENGELOLAAN_KINERJA_KS_PENILAI_PATH}/penilaian-kinerja/[npsn]/daftar-guru/penetapan-predikat-kinerja/riwayat`
      case 'draft':
        return `${PENGELOLAAN_KINERJA_KS_PENILAI_PATH}/penilaian-kinerja/[npsn]/daftar-guru/penetapan-predikat-kinerja`
      default:
        return `${PENGELOLAAN_KINERJA_KS_PENILAI_PATH}/penilaian-kinerja/[npsn]/langkah-penetapan-predikat-kinerja/panduan`
    }
  }

  let event = null
  switch (overrideState) {
    case 'done':
      event = {
        activityType: 'penilaian_ks_pk_click_cek_riwayat_pengiriman',
        screenName: 'ks_penetapan_kinerja',
        eventTrigger: 'ks_penilaian_hub',
      }
      break
    case 'unlocked':
      event = {
        activityType: 'penilaian_ks_pk_click_mulai',
        screenName: 'ks_penetapan_kinerja',
        eventTrigger: 'ks_penilaian_hub',
      }
      break
  }

  return (
    <LangkahObservasiCard
      {...props}
      CtaButtonProps={{
        ...props.CtaButtonProps,
        event,
      }}
      isLoading={isLoading}
      overrideState={overrideState}
      url={{
        pathname: ctaURL(),
        query: { npsn: props?.npsn },
      }}
    />
  )
}
